import {Injectable} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from './confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  private modalRef: NgbModalRef | null = null;
  private promiseResolve!: (value: boolean) => void;

  constructor(private readonly modalService: NgbModal) {
  }

  confirmDialog(title: string, message: string): Promise<boolean> {
    this.modalRef = this.modalService.open(ConfirmDialogComponent);
    const componentInstance = this.modalRef.componentInstance as ConfirmDialogComponent;
    componentInstance.title = title;
    componentInstance.message = message;

    return new Promise<boolean>((resolve) => {
      this.promiseResolve = resolve;
    });
  }

  confirm() {
    if (this.promiseResolve) {
      this.promiseResolve(true);
      this.closeModal();
    }
  }

  cancel() {
    if (this.promiseResolve) {
      this.promiseResolve(false);
      this.closeModal();
    }
  }

  private closeModal() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }
}
